const getters = {
    getProducts: (state) => {
        return _.orderBy(state.incomingOrderProducts, 'eta');
    },
    getProduct: (state) => (id) => {
        return _.toArray(state.incomingOrderProducts).find(product => product.id === id);
    },
    getProductsFromOrder: (state, getters, rootState, rootGetters) => (orderId) => {
        const order = rootGetters['incomingOrders/getOrder'](orderId)
        return _.filter(state.incomingOrderProducts, (product) => {
            return product.packingListNumber.toString() == order.packingListNumber.toString();
        });
    },
    getProductsFromCargo: (state) => (cargoId) => {
        return _.filter(state.incomingOrderProducts, (product) => {
            return product.cargoId.toString() == cargoId.toString();
        });
    },
    getProductsWithCargoAndOrderIncoming: (state, getters, rootState, rootGetters) => {
        return _.map(state.incomingOrderProducts, product => {
                const cargo = rootGetters['incomingCargo/getCargo'](product.cargoId);
                const order = rootGetters['incomingOrders/getOrder'](product.incomingOrderId);
                product.truckNumber = cargo.truckNumber;
                product.trailerNumber = cargo.trailerNumber;
                product.receiverName = (order && order.receiver && order.receiver.name)  ? order.receiver.name  : '';
                product.receiver = (order && order.receiver) ? order.receiver : {};
                if (!product.receiver.address && order) {
                    product.receiver = {
                        address: order.receiverAddress,
                        city: order.receiverCity,
                        zipcode: order.receiverZipcode
                    }
                }
                let status = '';
                if (product.amount === 0) {
                    status = 'done'; // Nothing to unload, so it's done
                } else if (!product.amountUnloaded) {
                    status = 'idle';
                } else if (product.amount > product.amountUnloaded && product.amountUnloaded > 0) {
                    status = 'busy';
                } else if (product.amount >= product.amountUnloaded) {
                    status = 'done';
                }
                product.state = status;
                // Voorkomen dat er nulls inzitten voor datatable
                Object.keys(product).forEach(key => {
                    if (product[key] === null) {
                        product[key] = '';
                    }
                })
                return product;
            });
    },
};

export default getters;